/**
 * ? @description : Modal for View student's data on spoc
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../../redux/features/appSlice";
import { Box, IconButton, MenuItem, Modal, Select, Tab, TextField } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Close } from "@mui/icons-material";
import { Table } from "react-bootstrap";
import "../../../../../../css/MappedProfileStudentModel.css"
import axios from "axios";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "800px",
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};



function StudentModal(props) {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [student, setStudent] = useState([]);
  // const [inputValueChange, setInputValueChange] = useState(true);
  /*added by Ramanan : form Validation state variable*/
  const [dataValidate, setDataValidate] = useState({})
  const [tabValue, setTabValue] = useState("1")
  const [studentLevel, setStudentLevel] = useState([])
  const [batchData, setBatchData] = useState([])
  const [editedStudentData, setEditedStudentData] = useState({
    student_name: "",
    whatsappno: "",
    spoken_language_2: "",
    spoken_language_3: "",
    spoken_language_4: "",
    spoken_language_5: "",
    spoken_language_6: "",
    student_age: "",
    education: "",
    level_reading_skill: "",
    class_contactno: "",
    student_status: "",
  });

  // * Student Id
  const id = props.tabledata[3];
  // const studentId = student.student_id;
  // console.log("normal id" + id);
  // console.log("My id" + studentId);

  
// console.log(student);
  // * Function Call
  useEffect(() => {
    // ? Get Method : Fetch Data From Server
    const controller = axios.CancelToken.source();

    (async () => {

      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `/student/${id}`,
            auth: true,
            data: null,
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            controller
          );

          setStudent(response.data);
        } catch (error) {
          if(!axios.isCancel(error)){
            dispatch(
              showSnackbar({
                message: "Unable to get student data. Please try again later.",
                severity: "error",
              })
            );
          }
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [id, dispatch]);

  // * Assign Data to State Variable
  useEffect(() => {
    if (student.length > 0) {
      setEditedStudentData(prev => ({
        ...prev,
        student_name: student[0].student_name,
        whatsappno: student[0].whatsappno,
        spoken_language_2: student[0].spoken_language_2,
        spoken_language_3: student[0].spoken_language_3,
        spoken_language_4: student[0].spoken_language_4,
        spoken_language_5: student[0].spoken_language_5,
        spoken_language_6: student[0].spoken_language_6,
        student_age: student[0].student_age,
        education: student[0].education,
        level_reading_skill: student[0].level_reading_skill,
        class_contactno: student[0].class_contactno,
        student_status: student[0].student_status,
        sponser_name : student[0].sponser_name,
        sponser_contactno : student[0].sponser_contactno,
        sponser_address : student[0].sponser_address
      }));
    }
  }, [student]);

  //GET Request : To fetch Student Level
  useEffect(() => {
    const controller = axios.CancelToken.source();
      (async() => {
        if(id !== undefined){
          try{
            let options = {
              method: "POST",
              url: `/student/level/studentleveldetails`,
              auth: true,
              data: {student_id : id},
              token:{cancelToken: controller.token}
            };
    
            const {data} = await Axios(
              options.method,
              options.url,
              options.auth,
              options.data,
              options.token,
            );
            setStudentLevel(data);
          }catch(err){
            if(!axios.isCancel(err)){
              console.log(err);
              dispatch(
                showSnackbar({
                  message: "Unable to fetch student level. Please try again later.",
                  severity: "error",
                })
              );
            }
          }
      }
    })();
    return () => {
      controller.cancel();
  }
  },[id, dispatch])


  //GET Request : To fetch Student Batch information
  useEffect(() => {
  // const getStudentBatchInfo = 
  const controller = axios.CancelToken.source();
  (async() => {
    if(id !== undefined){
      try{
        let options = {
          method: "GET",
          url: `student/map/get_mapped_teacher/${id}`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const {data} = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        setBatchData(data);
      }catch(err){
        if(!axios.isCancel(err)){
          dispatch(
            showSnackbar({
              message: "Unable to fetch Batch informations. Please try again later.",
              severity: "error",
            })
          );
        }
      }
    }
  })();
  return () => {
    controller.cancel();
}
  },[id, dispatch]);

  const batchTable = batchData.map((data, index) => (
      <tr key={index}>
       
        <td><strong>{index+1}</strong></td>
        {/* <td>{data.batch_name}</td> */}
        <td>{data.teacher_name}</td>
      </tr>
       
    ),
    )
  
  return (
   
    student.length > 0 && (
      <Modal
        open={props.show}
        onClose={props.onHide}
      >
        <Box sx={style} >
          <TabContext value={tabValue}>
                {/* Tab Headings */}
                <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: "row",  alignItems: "center", justifyContent: "space-between" }}>
                    <TabList
                      value={tabValue}
                      onChange={(e, newValue) => setTabValue(newValue)}
                    >
                      <Tab label="Primary" value="1" />
                      <Tab label="Mapped Teachers" value="2" />
                      <Tab label="Level" value="3" />
                    </TabList>
                    <IconButton onClick={props.onHide}>
                      <Close/>
                    </IconButton>
                </Box>
                <TabPanel value="1">
                    <div className="d-flex justify-content-start" style={{width: "max-content"}}>
                      <div>
                        <div style={{ display: "none", alignItems: "center" }}>
                          <p style={{ width: "160px" }}>Unique Id&nbsp;:</p>
                          <input type="text" value={student[0].student_id} disabled />
                      </div>
                     
                      {/* <br /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "160px" }}>Name&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.student_name}
                          onChange={(e) => {
                              e.target.value.length < 5 ? setDataValidate(prevData => {
                                return {...prevData, isNameError : true}
                              }) : setDataValidate(prevData => {
                                return {...prevData, isNameError : false}
                              })
                              setEditedStudentData({
                                ...editedStudentData,
                                student_name: e.target.value,
                              })
                            }
                          }
                          disabled={inputValueChange}--
                        /> */}
                        <strong>{editedStudentData.student_name}</strong>
                      </div>
                      <p style={{color : "red"}}>{dataValidate.isNameError && "Enter a valid name"}</p>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "160px" }}>WhatsApp Number&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.whatsappno}
                          onChange={(e) =>{
                              e.target.value.length !== 10 ? setDataValidate(prevData => {return {...prevData, isWhatsappError : true}})
                              : setDataValidate(prevData => {return {...prevData, isWhatsappError : false}})
                              setEditedStudentData({
                                ...editedStudentData,
                                whatsappno: e.target.value,
                              })
                            }
                          }
                          disabled={inputValueChange}--
                        /> */}
                        <strong>{editedStudentData.whatsappno}</strong>
                      </div>
                      <p style={{color : "red"}}>{dataValidate.isWhatsappError && "Whatsapp number must contain 10 digits"}</p>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "160px" }}>Contact Number&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.class_contactno}
                          onChange={(e) => {
                              e.target.value.length !== 10 ? setDataValidate(prevData => {return {...prevData, isContactError : true}})
                              : setDataValidate(prevData => {return {...prevData, isContactError : false}})
                              setEditedStudentData({
                                ...editedStudentData,
                                class_contactno: e.target.value,
                              })
                            }
                          }
                          disabled={inputValueChange}-- 
                        /> */}
                        <strong>{editedStudentData.class_contactno}</strong>
                      </div>
                      <p style={{color : "red"}}>{dataValidate.isContactError && "Contact number must contain 10 digits"}</p>
                      <br />
                      <div style={{ display: "flex", alignItems: "center" }}>
                          <p style={{ width: "160px" }}>Role&nbsp;:</p>
                          {/* <input type="text" value={student[0].role} disabled /> */}
                          <strong>{student[0].role}</strong>
                      </div>
                      <br />
                      <div style={{ display: "flex", alignItems: "center" }}>
                          <p style={{ width: "160px" }}>Mapped Status&nbsp;:</p>
                          {/* <input type="text" value={student[0].student_mapped_status} disabled /> */}
                          <strong>{student[0].student_mapped_status}</strong>
                      </div>
                     
                    </div>
                    <div className="mx-4">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Age&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.student_age}
                          onChange={(e) =>
                            setEditedStudentData({
                              ...editedStudentData,
                              student_age: e.target.value,
                            })
                          }
                          disabled={inputValueChange}-- 
                        /> */}
                        <strong>{editedStudentData.student_age}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Education&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.education}
                          onChange={(e) =>{
                            e.target.value.length < 5 ? setDataValidate(prevData => {
                              return {...prevData, isEducationError : true}
                            }) : setDataValidate(prevData => {
                              return {...prevData, isEducationError : false}
                            })
                            setEditedStudentData({
                              ...editedStudentData,
                              education: e.target.value,
                            })}
                          }
                          disabled={inputValueChange}--
                        /> */}
                        <strong>{editedStudentData.education}</strong>
                      </div>
                      <p style={{color : "red"}}>{dataValidate.isEducationError && "Please Enter a valid Education"}</p>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Reading Skill&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.level_reading_skill}
                          onChange={(e) => {
                            e.target.value.length < 5 ? setDataValidate(prevData => {
                              return {...prevData, isReadingSkillError : true}
                            }) : setDataValidate(prevData => {
                              return {...prevData, isReadingSkillError : false}
                            })
                            setEditedStudentData({
                              ...editedStudentData,
                              level_reading_skill: e.target.value,
                            })}
                          }
                          disabled={inputValueChange}--
                        /> */}
                        <strong>{editedStudentData.level_reading_skill}</strong>
                      </div>
                      <p style={{color : "red"}}>{dataValidate.isReadingSkillError && "Please Enter a valid skill"}</p>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Registered Date&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={student[0].screated_at.split("T")[0]}
                          disabled
                        /> */}
                        <strong>{student[0].screated_at.split("T")[0]}</strong>
                      </div>
                      <br />
                      <div style={{ display: "flex", alignItems: "center" }}>
                          <p style={{ width: "150px" }}>Status&nbsp;:</p>
                          {/* <input type="text" value={editedStudentData.student_status} disabled /> */}
                          <strong>{editedStudentData.student_status}</strong>
                      </div>
                    </div>
                    <div >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "130px" }}>Language 1&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={student[0].spoken_language_1}
                          disabled
                        /> */}
                        <strong>{student[0].spoken_language_1}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "130px" }}>Language 2&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.spoken_language_2}
                          onChange={(e) =>
                            setEditedStudentData({
                              ...editedStudentData,
                              spoken_language_2: e.target.value,
                            })
                          }
                          disabled
                        /> */}
                                           <strong>{editedStudentData.spoken_language_2}</strong>

                      </div>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "130px" }}>Language 3&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.spoken_language_3}
                          onChange={(e) =>
                            setEditedStudentData({
                              ...editedStudentData,
                              spoken_language_3: e.target.value,
                            })
                          }
                          disabled={inputValueChange} -- 
                        /> */}
                        <strong>{editedStudentData.spoken_language_3}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "130px" }}>Language 4&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.spoken_language_4}
                          onChange={(e) =>
                            setEditedStudentData({
                              ...editedStudentData,
                              spoken_language_4: e.target.value,
                            })
                          }
                          disabled={inputValueChange}-- 
                        /> */}
                        <strong>{editedStudentData.spoken_language_4}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "130px" }}>Language 5&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.spoken_language_5}
                          onChange={(e) =>
                            setEditedStudentData({
                              ...editedStudentData,
                              spoken_language_5: e.target.value,
                            })
                          }
                          disabled={inputValueChange}--
                        /> */}
                        <strong>{editedStudentData.spoken_language_5}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "130px" }}>Language 6&nbsp;:</p>
                        {/* <input
                          type="text"
                          value={editedStudentData.spoken_language_6}
                          onChange={(e) =>
                            setEditedStudentData({
                              ...editedStudentData,
                              spoken_language_6: e.target.value,
                            })
                          }
                          disabled={inputValueChange}--
                        /> */}
                        <strong>{editedStudentData.spoken_language_6}</strong>
                      </div>
                    </div>

                    
                  </div>
                </TabPanel>
                <TabPanel value="2">

                <div className="d-flex flex-column">
                 {/* <div className="d-flex flex-row justify-content-start pt-3 pb-5">
                   <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                     <p>Group Status&nbsp;:</p>
                     <p>
                       <strong>{student[0].group_status}</strong>
                     </p>
                   </div>

                   <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                     <p>Mapped Status&nbsp;:</p>
                     <p>
                       <strong>{student[0].student_mapped_status}</strong>
                     </p>
                   </div>

                   <div style={{ display: "flex", width: "250px", gap: "20px"}}>
                     <p>Role&nbsp;:</p>
                     <p>
                       <strong>{student[0].role}</strong>
                     </p>
                   </div>

                   <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                     <p>Status&nbsp;:</p>
                     <p>
                       <strong>{editedStudentData.student_status}</strong>
                     </p>
                  </div>

                </div> */}

                <div>
                  {batchData.length > 0 ? 
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>SI.NO</th>
                          {/* <th>Batch Name</th> */}
                          <th>Mapped to teacher</th>
                        </tr>
                      </thead>
                      <tbody>
                        {batchTable}
                      </tbody>
                    </Table> : 
                    <p style={{display : "flex", justifyContent: "center", color: "red"}}>There is no batch information for this student</p>
                  }
                </div>

              </div>
                </TabPanel>
                <TabPanel value="3">
                {studentLevel.length > 0 ? 
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Level</th>
                        <th>Level Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentLevel.map(level => {
                        return(
                          <tr>
                            <td><strong>{level.level_name}</strong></td>
                            <td>{level.level_status}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table> :
                  <p style={{display : "flex", justifyContent: "center", color: "red"}}>There is no level information for this student</p>}
                </TabPanel>
          </TabContext>
        </Box>
      </Modal>
    )
  );
}

export default StudentModal;



// <Tabs
//             className="mb-3"
//             id="uncontrolled-tab-example"
//             defaultActiveKey="primary"
//           >
//             <Tab eventKey="primary" title="Primary">
//               
//             </Tab>

//             <Tab eventKey="other" title="Group">
//               <div className="d-flex flex-column">
//                 <div className="d-flex flex-row justify-content-start pt-3 pb-5">
//                   <div style={{ display: "flex", width: "280px", gap: "20px"}}>
//                     <p>Group Status&nbsp;:</p>
//                     <p>
//                       <strong>{student[0].group_status}</strong>
//                     </p>
//                   </div>

//                   <div style={{ display: "flex", width: "280px", gap: "20px"}}>
//                     <p>Mapped Status&nbsp;:</p>
//                     <p>
//                       <strong>{student[0].student_mapped_status}</strong>
//                     </p>
//                   </div>

//                   <div style={{ display: "flex", width: "250px", gap: "20px"}}>
//                     <p>Role&nbsp;:</p>
//                     <p>
//                       <strong>{student[0].role}</strong>
//                     </p>
//                   </div>

//                   <div style={{ display: "flex", width: "280px", gap: "20px"}}>
//                     <p>Status&nbsp;:</p>
//                     {/* <input
//                       type="text"
//                       value={editedStudentData.student_status}
//                       onChange={(e) =>
//                         setEditedStudentData({
//                           ...editedStudentData,
//                           student_status: e.target.value,
//                         })
//                       }
//                       disabled={inputValueChange}
//                     /> */}

//                     <select 
//                       // disabled={inputValueChange}
//                       value={editedStudentData.student_status}
//                       onChange={(e) => setEditedStudentData({
//                         ...editedStudentData,
//                         student_status : e.target.value
//                       })}
//                     >
//                       <option value="active">Active</option>
//                       <option value="inactive">In-active</option>
//                     </select>
//                   </div>

//                 </div>

//                 <div>
//                   {batchData.length > 0 ? 
//                     <Table striped bordered hover>
//                       <thead>
//                         <tr>
//                           <th>Batch Id</th>
//                           <th>Batch Name</th>
//                           <th>Mapped to teacher</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {batchTable}
//                       </tbody>
//                     </Table> : 
//                     <p style={{display : "flex", justifyContent: "center", color: "red"}}>There is no batch information for this student</p>
//                   }
//                 </div>

//               </div>
//             </Tab>
//             <Tab eventKey="student-level" title="Level">
//               
//             </Tab>
//           </Tabs>